import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useEffectOnce, useSelect, useViewport } from '@chilecompra/react-kit'
import { Select } from '@chilecompra/react-kit/components'
import Jumbotron from '../../components/Basics/Jumbotron'
import { COVID_IMAGE_URL } from '../../config/settings/constants'
import ProtectByFeatures from '../../security/ProtectByFeatures'
import { onGetContingencyOptionsThunk } from './Contingencies.actions'
import {
  BoldText,
  Card,
  ContainerImg,
  CustomTypography,
  GridContainer,
  GridItem,
  Image,
  Root
} from './Contingencies.styles'

/**
 * The Contingencies's container.
 */
const Contingencies = () => {
  const dispatch = useDispatch()
  const { contingencyOptions } = useSelector(state => state.contingencies)
  const {
    size: { isUpToMedium }
  } = useViewport()

  const {
    error: optionError,
    value: optionValue,
    onChange: handleChangeOption
  } = useSelect({
    initialValue: 2
  })

  useEffectOnce(() => {
    dispatch(onGetContingencyOptionsThunk())
  })

  return (
    <Root>
      {isUpToMedium && (
        <ContainerImg>
          <Image src={COVID_IMAGE_URL} />
        </ContainerImg>
      )}
      <GridContainer>
        <GridItem xs={12}>
          <Jumbotron color="blue" height={isUpToMedium ? '295px' : 'auto'}>
            <CustomTypography
              align={isUpToMedium ? 'inherit' : 'center'}
              color="white"
              fontSize="14px"
              lineHeight="20px"
              margin={isUpToMedium ? '8px 0 0' : '24px 0 0'}
              variant="body1"
              width={isUpToMedium ? '300px' : '100%'}
            >
              Datos Abiertos / Compras por contingencia
            </CustomTypography>
            <CustomTypography
              color="white"
              fontSize="47px"
              lineHeight="54px"
              margin={isUpToMedium ? '48px 0 0' : '48px 0'}
              variant="h1"
              width={isUpToMedium ? '400px' : '100%'}
            >
              Compras públicas por <BoldText>contingencia</BoldText>
            </CustomTypography>
            <ProtectByFeatures rule={features => features['contingencies.select.options']}>
              <Card color="blank" margin="48px 0 0" width="470px">
                <Select
                  error={optionError}
                  options={contingencyOptions}
                  value={optionValue}
                  onChange={handleChangeOption}
                />
              </Card>
            </ProtectByFeatures>
          </Jumbotron>
        </GridItem>
      </GridContainer>
    </Root>
  )
}

export default Contingencies
